export default {
    STORE_KEY: 'a56z0fzrNpl^2',
    //Dev
    //HOST_URL: 'http://sf.devkot.ru/',
    //API_URL: 'http://sf.devkot.ru/server/public/api/v1',
    //PUBLIC_URL: 'http://sf.devkot.ru/server/public/uploads/',

    //Prod
    HOST_URL: 'http://185.87.192.213/',
    API_URL: 'http://185.87.192.213/server/public/api/v1',
    PUBLIC_URL: 'http://185.87.192.213/server/public/uploads/',
    //STORAGE_URL: '',
   
    getHeaders: function () {
      return {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
      }
    }
  };